var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNftsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_896_155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 50.75C38.8071 50.75 50 39.5571 50 25.75C50 11.9429 38.8071 0.75 25 0.75C11.1929 0.75 0 11.9429 0 25.75C0 39.5571 11.1929 50.75 25 50.75Z",
    fill: "#00587E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.999 14.75H16.001C14.8959 14.75 14 15.6459 14 16.751V34.749C14 35.8541 14.8959 36.75 16.001 36.75H33.999C35.1041 36.75 36 35.8541 36 34.749V16.751C36 15.6459 35.1041 14.75 33.999 14.75Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.75 18.75H18.25C18.1119 18.75 18 18.8619 18 19V32.5C18 32.6381 18.1119 32.75 18.25 32.75H31.75C31.8881 32.75 32 32.6381 32 32.5V19C32 18.8619 31.8881 18.75 31.75 18.75Z",
    fill: "#00587E",
    stroke: "#00587E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.478 22.89H33.478",
    stroke: "#00587E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.478 29.57H33.478",
    stroke: "#00587E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0474 25.75H29.5474",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8452 23.5952L21.7846 22.5346",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4766 28.3891L22.7266 29.6881",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 28.7557C26.6599 28.7557 28.0056 27.41 28.0056 25.75C28.0056 24.09 26.6599 22.7443 24.9999 22.7443C23.3398 22.7443 21.9941 24.09 21.9941 25.75C21.9941 27.41 23.3398 28.7557 24.9999 28.7557Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_896_155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftsIcon);
export default __webpack_public_path__ + "static/media/nfts-icon.f53f1eb4ccee32d5cd694c3fbbebd782.svg";
export { ForwardRef as ReactComponent };